export class ImageUploadService {
  constructor(ApiService, Upload, FileUploadService) {
    "ngInject";

    this.apiService = ApiService;
    this._upload = Upload;
    this.fileUploadService = FileUploadService;
  }
  upload(details) {
    // const resourceUrl = this.apiService.getResourceUrl('image-upload');
    // return this._upload.upload({
    //     url: resourceUrl,
    //     data: {
    //         container: details.container,
    //         image: (details.image instanceof File) ? details.image : this._upload.dataUrltoBlob(details.image, details.name)
    //     },
    //     headers: { 'Content-Type': details.type }
    // });
    const image =
      details.image instanceof File
        ? details.image
        : this._upload.dataUrltoBlob(details.image, details.name);
    return this.fileUploadService
      .uploadFile(image, details.container)
      .then((details) => details);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/libs/image-upload/image-upload.service.js